export const sanitizeNum = (v) => String(v ?? '').replace(/[^0-9.]/g, '');
